import React, {Component} from 'react';

export default class KirokuTitlepage extends Component {
    render() {
        return (
            <span className='title-page'>{this.props.title}</span>
        )
    }
}
